import { ReadingType } from 'infrastructure/enums';
import { getActivityThresholdsValues } from 'utils';

import s from './styles.module.scss';
import { getWeightRiskContent } from '../../utils/get-reading-info';

import type { ReadingStatus } from 'infrastructure/enums';
import type { IPatientThresholds } from 'infrastructure/interfaces';
import type {
  TStatuses,
  TThresholdName,
  Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { Nullable } from 'infrastructure/types';
import type { FC } from 'react';

interface ThresholdCellProps {
  values: Value;
  statuses: TStatuses;
  readingType: ReadingType;
  globalStatus: ReadingStatus;
  thresholds: IPatientThresholds;
  thresholdName?: Nullable<TThresholdName>;
}

const ThresholdCell: FC<ThresholdCellProps> = ({
  values,
  statuses,
  readingType,
  globalStatus,
  thresholds,
  thresholdName,
}) => {
  const riskItems = getActivityThresholdsValues(
    globalStatus,
    values,
    statuses,
    thresholds,
    readingType,
  );
  const weightRiskContent = () => {
    const text = getWeightRiskContent(thresholds, thresholdName);
    if (!text) return null;
    const [risk, value] = text.split('≥ ');

    return (
      <div data-cy="reading-thresholds" className={s['risk-items']}>
        <p>
          <span>{risk}</span>{' '}
          <span>
            <b>≥ {value}</b>
          </span>
        </p>
      </div>
    );
  };
  return readingType === ReadingType.Weight ? (
    weightRiskContent()
  ) : (
    <div data-cy="reading-thresholds" className={s['risk-items']}>
      {riskItems.length > 0 &&
        riskItems.map((riskItem: string) => {
          const [risk, value] = riskItem?.split(':');

          return (
            <p key={riskItem}>
              <span>{risk}:</span>
              <span>{value}</span>
            </p>
          );
        })}
    </div>
  );
};
export default ThresholdCell;
